import { render, staticRenderFns } from "./LiveChatIcon.vue?vue&type=template&id=45978b99"
import script from "./LiveChatIcon.vue?vue&type=script&lang=js"
export * from "./LiveChatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports